import { Controller } from "@hotwired/stimulus";

const STORAGE_KEY = "help-theme";
const DEFAULT_THEME = "dusk";

// Flips every pre-rendered shot on the page between the app's themes. The shots
// carry the tokens for every theme, so this only restamps data-theme.
export default class extends Controller {
  static targets = ["button"];

  connect() {
    this.apply(this.storedTheme());
  }

  choose(event) {
    const theme = event.currentTarget.dataset.theme;
    this.apply(theme);
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch {
      // Private mode or blocked storage. The choice still applies for this page.
    }
  }

  apply(theme) {
    this.element.querySelectorAll(".screen").forEach((screen) => {
      screen.setAttribute("data-theme", theme);
    });
    this.buttonTargets.forEach((button) => {
      const active = button.dataset.theme === theme;
      button.setAttribute("aria-pressed", active ? "true" : "false");
    });
  }

  storedTheme() {
    try {
      return localStorage.getItem(STORAGE_KEY) ?? DEFAULT_THEME;
    } catch {
      return DEFAULT_THEME;
    }
  }
}
